import React from 'react';
import ObjectCreatedInfo from '../../../../../Components/Elements/ObjectCreatedInfo';
import { BlockFormProps } from '../../types';

interface InfoTabProps {
    kedo: any;
    item?: BlockFormProps['item'];
}

const InfoTab: React.FC<InfoTabProps> = ({
    kedo,
    item,
}) => {
    if (!item?.id) return null;
    return <ObjectCreatedInfo kedo={kedo} item={item} />;
};

export default InfoTab;